import Swiper, { EffectFade, Autoplay, Pagination } from 'swiper'
import 'swiper/css'
import 'swiper/css/effect-fade'
import 'swiper/css/autoplay'
import 'swiper/css/pagination'
export class InterviewKvSlider {
  constructor() {
    if (document.getElementById('js-interview_kv_slider') === null) return
    const num = document.querySelector('.js-interview_kv_num')
    const slider = document.getElementById('js-interview_kv_slider')
    const slideList = slider.querySelectorAll('.slide')
    let bar = num.querySelector('.bar')
    let speed = 6000

    let swiper = new Swiper('#js-interview_kv_slider', {
      modules: [EffectFade, Autoplay, Pagination],
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      autoplay: {
        delay: speed,
        disableOnInteraction: false,
      },
      pagination: {
        el: '.js-interview_kv_dot',
        clickable: true,
      },
      speed: 2000,
      on: {
        init: () => {
          num.classList.add('is-act')
        },
      },
    })

    swiper.on('slideChangeTransitionStart', function () {
      let current = document.getElementById('js-interview_kv_num_current')
      if (swiper.activeIndex > slideList.length) {
        current.innerHTML = 1
      } else {
        current.innerHTML = swiper.activeIndex
      }

      ;(bar.style.transitionDuration = '0s'), (bar.style.transform = 'scaleY(0)')
    })

    swiper.on('slideChangeTransitionEnd', function () {
      ;(bar.style.transitionDuration = speed + 'ms'), (bar.style.transform = 'scaleY(1)')
    })
  }
}
